import { apiCache } from './apiCache';
import * as eventsAPI from './eventsAPI';
import { fetchUserBalance, fetchPaymentBeltExchange } from './profileAPI';
import { fetchGenreGames, fetchLiveNowGames } from './authAPI';

// Enhanced wrapper functions that use caching and deduplication
export const fetchPopularEventsEnhanced = async (
  username: string, 
  limit: number, 
  paginationKey?: string
) => {
  return apiCache.executeWithCache(
    'fetchPopularEvents',
    eventsAPI.fetchPopularEvents,
    [username, limit, paginationKey],
    2 * 60 * 1000 // 2 minutes cache
  );
};

export const fetchUpcomingEventsEnhanced = async (
  username: string, 
  limit: number, 
  paginationKey?: string
) => {
  return apiCache.executeWithCache(
    'fetchUpcomingEvents',
    eventsAPI.fetchUpcomingEvents,
    [username, limit, paginationKey],
    2 * 60 * 1000 // 2 minutes cache
  );
};

export const fetchRecommendedEventsEnhanced = async (
  username: string, 
  limit: number, 
  paginationKey?: string
) => {
  return apiCache.executeWithCache(
    'fetchRecommendedEvents',
    eventsAPI.fetchRecommendedEvents,
    [username, limit, paginationKey],
    2 * 60 * 1000 // 2 minutes cache
  );
};

export const fetchPastEventsEnhanced = async (
  accessToken: string, 
  limit: number, 
  paginationKey?: string
) => {
  return apiCache.executeWithCache(
    'fetchPastEvents',
    eventsAPI.fetchPastEvents,
    [accessToken, limit, paginationKey],
    2 * 60 * 1000 // 2 minutes cache
  );
};

// Enhanced profile API functions with caching
export const fetchUserBalanceEnhanced = async (accessToken: string) => {
  return apiCache.executeWithCache(
    'fetchUserBalance',
    fetchUserBalance,
    [accessToken],
    5 * 60 * 1000 // 5 minutes cache
  );
};

export const fetchPaymentBeltExchangeEnhanced = async (accessToken: string) => {
  return apiCache.executeWithCache(
    'fetchPaymentBeltExchange',
    fetchPaymentBeltExchange,
    [accessToken],
    5 * 60 * 1000 // 5 minutes cache
  );
};

export const fetchGenreGamesEnhanced = async () => {
  return apiCache.executeWithCache(
    'fetchGenreGames',
    fetchGenreGames,
    [],
    10 * 60 * 1000 // 10 minutes cache (genres don't change often)
  );
};

export const fetchLiveNowGamesEnhanced = async () => {
  return apiCache.executeWithCache(
    'fetchLiveNowGames',
    fetchLiveNowGames,
    [],
    2 * 60 * 1000 // 2 minutes cache (live games change frequently)
  );
};

// Clear all cache when needed
export const clearEventsCache = () => {
  apiCache.clearCache('fetchPopularEvents');
  apiCache.clearCache('fetchUpcomingEvents');
  apiCache.clearCache('fetchRecommendedEvents');
  apiCache.clearCache('fetchPastEvents');
  apiCache.clearCache('fetchLiveNowGames');
};

export const clearProfileCache = () => {
  apiCache.clearCache('fetchUserBalance');
  apiCache.clearCache('fetchPaymentBeltExchange');
  apiCache.clearCache('fetchGenreGames');
};

export const clearAllCache = () => {
  clearEventsCache();
  clearProfileCache();
};